<nav class="navbar navbar-expand-lg py-2 fixed-top">
  <div class="container-fluid d-flex py-2 justify-content-between align-items-center">

    <!-- Brand Logo -->
    <a class="navbar-brand" routerLink="/">
      <img src="assets/img/new/athulya-agencies.png" class="logo ms-3" alt="Logo" />
    </a>

    <!-- Desktop Items -->
    <div class="d-none d-lg-flex align-items-center gap-3">
      <!-- Search Input Desktop -->
      <div class="search-container position-relative">
        <input 
          id="navbar-search-input"
          type="text" 
          class="form-control premium-search-input" 
          placeholder="Search products..." 
          [(ngModel)]="searchQuery"
          (input)="onSearchInput()"
        >
        <i class="bi bi-search search-icon"></i>
        <i class="bi bi-x-circle-fill clear-icon" *ngIf="searchQuery" (click)="clearSearch()"></i>
      </div>
      <!-- Pay Now Button -->
      <button
        class="pay-now-btn"
        (click)="openQrModal()"
        aria-label="Pay Now"
      >
        <i class="bi bi-qr-code-scan"></i>
        <span>Pay Now</span>
      </button>

      <!-- Login Button -->
      <a
        class="login-btn"
        [routerLink]="['/login']"
        aria-label="Login"
      >
        <i class="bi bi-person-circle"></i>
        <span>Login</span>
      </a>
    </div>

    <!-- Mobile Toggle -->
    <button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar">
      <i class="bi bi-list fs-3"></i>
    </button>
  </div>

  <!-- Offcanvas for Mobile -->
  <div class="offcanvas offcanvas-end d-lg-none" tabindex="-1" id="offcanvasNavbar">
    <div class="offcanvas-header">
      <img src="../../../assets/img/new/athulya-agencies.png" class="mobile-logo" alt="Logo" />
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
    </div>
    <div class="offcanvas-body">
      <!-- Search Input Mobile -->
      <div class="search-container position-relative mb-4">
        <input 
          type="text" 
          class="form-control premium-search-input" 
          placeholder="Search products..." 
          [(ngModel)]="searchQuery"
          (input)="onSearchInput()"
        >
        <i class="bi bi-search search-icon"></i>
        <i class="bi bi-x-circle-fill clear-icon" *ngIf="searchQuery" (click)="clearSearch()"></i>
      </div>

      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link josefin-sans-semibold pay-now-mobile" (click)="openQrModal()" data-bs-dismiss="offcanvas">Pay Now</a>
        </li>
        <li class="nav-item">
          <a class="nav-link josefin-sans-semibold" [routerLink]="['/login']">Login</a>
        </li>
        <!-- Add more nav items here if needed -->
      </ul>
    </div>
  </div>
</nav>

<!-- QR Payment Modal -->
<div class="qr-modal-overlay" *ngIf="showQrModal" (click)="closeQrModal()">
  <div class="qr-modal-card" (click)="$event.stopPropagation()">
    <button class="qr-modal-close" (click)="closeQrModal()" aria-label="Close">
      &times;
    </button>
    <div class="qr-modal-header">
      <i class="bi bi-shield-lock-fill"></i>
      <h3>Scan & Pay</h3>
      <p>Scan the QR code below using any UPI app to make your payment</p>
    </div>
    <div class="qr-modal-body">
      <div class="qr-image-wrapper">
        <img src="assets/img/new/payment-qr.png" alt="Payment QR Code" />
      </div>
    </div>
    <div class="qr-modal-footer">
      <div class="upi-apps">
        <span>Supported Apps:</span>
        <div class="app-badges">
          <span class="badge">Google Pay</span>
          <span class="badge">PhonePe</span>
          <span class="badge">Paytm</span>
          <span class="badge">UPI</span>
        </div>
      </div>
    </div>
  </div>
</div>
